import React from 'react';
import ReactDOM from 'react-dom';
import Accordion from './Accordion';
import '../../assets/css/modal.css';
import { isNullOrUndefined, checkUrlPath } from './CommonFunctions';

class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.rootElement = document.getElementById('root');
        this.dialogWrapper = document.createElement('div');
        this.popupHeight = "200px";
    }

    componentDidMount() {
        this.rootElement.appendChild(this.dialogWrapper);
        const overlay = document.createElement('div');
        overlay.classList.add('modal');
        overlay.classList.add('page-overlay');
        this.dialogWrapper.appendChild(overlay);
        overlay.addEventListener('click', (e)=> {
            this.props.CloseCallBack();
        });  
    }
   
    render() {
        return ReactDOM.createPortal(
            <DialogContent Header={this.props.Header} Items={this.props.Content} DialogRef={this.props.DialogRef} getPopupContent={this.props.GetPopupData} getAccordionContent={this.props.GetAccordionData} DialogStyle={this.props.DialogStyle} CloseAction={this.props.CloseCallBack} ContentStyle={this.props.ContentStyle}/>,
            this.dialogWrapper
          );
    }
}

export default ModalDialog


class DialogContent extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidUpdate() {
        if(!isNullOrUndefined(document.querySelector('.modal_header .modal_x'))) {
            document.querySelector('.modal_header .modal_x').focus();
        }  
    }

    handleKeyActions(e) {

        const isModalX = e.target.classList.contains('modal_x');
        const isEnterKey = e.keyCode === 13;
        const isEscapeKey = e.keyCode === 27;
        const isTabkey = e.keyCode === 9;
        const isPageDown = e.keyCode === 34;
        const isShiftKey = e.shiftKey;
        const myUL = document.getElementById("ularticlelist");
        const list = myUL.getElementsByTagName("li");
        const lastListItem = list[list.length - 1];
        const dummyE1 = document.getElementById('btnClosebutton');
        const isFocused = document.activeElement === dummyE1;
        const dataitem = e.target.parentElement.getAttribute('data-item-index');

        if ((isModalX && isEnterKey) || isEscapeKey) {
            this.props.CloseAction();
        }
        if (isPageDown) {
            this.handlePageDownKey(e, dummyE1);
        }
        if (isTabkey) {
            lastListItem.removeAttribute('tabindex');
        }
        if (isTabkey && isShiftKey && isFocused) {
            this.handleShiftTabFocusKey(e, list, lastListItem);
        }
        if (isTabkey && !isFocused && !isShiftKey) {
            this.handleTabNonFocusNonShiftKey(e, dataitem, lastListItem, dummyE1);
        }
        if (isTabkey && !isFocused && isShiftKey) {
            this.handleTabNonFousShiftKey(e, dataitem, lastListItem, list)
        }
    }

    handlePageDownKey(e, dummyE1) {
        dummyE1.style.visibility = "hidden";
        setTimeout(() => {
            try {
                dummyE1.style.visibility = "visible";
            } catch (e) { }
        }, 5);
    }
    
    handleShiftTabFocusKey(e, list, lastListItem) {
        e.preventDefault();
        if (list.length > 0) {
            if (lastListItem.id != "") {
                var accordions = Array.from(list).filter((li) => li.id == "liaccordionheading");
                const lastAccordion = accordions[accordions.length - 1];
                if (lastListItem.id == "liaccordionList" && lastAccordion.ariaExpanded == "false") {
                    lastAccordion.setAttribute("tabIndex", "0");
                    lastAccordion.focus();
                }
                else {
                    lastListItem.children[0].setAttribute("tabIndex", "0");
                    lastListItem.children[0].focus();
                }
            }
        }
    }

    handleTabNonFocusNonShiftKey(e, dataitem, lastListItem, dummyE1) {
        try {
            if (dataitem != null) {
                if ((e.target.parentElement.nextElementSibling == null) && lastListItem == e.target.parentElement) {
                    e.preventDefault();
                    dummyE1.style.visibility = "hidden";
                    setTimeout(() => {
                        try {
                            dummyE1.style.visibility = "visible";
                            dummyE1.focus();
                        } catch (e) { }
                    }, 100);
                }
            }
        } catch (e) { }
    }

    handleTabNonFousShiftKey(e, dataitem, lastListItem, list) {
        try {
            if (dataitem != null) {
                if (e.target.parentElement.nextElementSibling == null && lastListItem == e.target.parentElement) {
                    if (list.length > 0) {
                        if (lastListItem.id != "") {
                            lastListItem.setAttribute("tabIndex", "0");
                            lastListItem.focus();
                        }
                    }
                }
            }

        } catch (e) { }
    }

    render() {
        let localInstance = this;
        if(this.props.Items.length > 0) {
            return (
                <div aria-hidden="false" id="modalOverlay" ref={this.props.DialogRef} className="w_modal m_articleModal m_tooltipmodal-width vzrf active" data-modal="payBill" role="dialog" style={this.props.DialogStyle} onKeyDown={this.handleKeyActions.bind(this)} tabIndex="-1">
                    <div className="modal-header" data-modal-header="">
                        <div className="modal_header article-modal_header" data-modal-header="">
                            <h2 className="text-black h5">{this.props.Header}</h2>
                            <button id="btnClosebutton" aria-label="Click here or press escape key to close the modal" tabIndex="0"  className="modal_x m_right m_articleModal-close" data-close-modal="" onClick={this.props.CloseAction} >
                                &nbsp;</button>
                        </div>
                    </div>
                    <div className="modal_content padding-top-zero padding-bottom-large">
                        <div className="padding-vert-small">
                            <ul id="ularticlelist" className="w_list-control m_article-list" data-list-control="" key="Dialog_Content">
                            {
                                this.props.Items.map((item, index)=> {
                                    if(item.isaccordion !== "true") {
                                    return <li id="liarticleList" data-item-index={index} className="links" key={"accItem"+index}>
                                        <a className="m_next" href={checkUrlPath(item.linkurl)} data-track={item.linktext} tabIndex="0" >{item.linktext}</a>
                                    </li>
                                    } else {
                                    return <Accordion HeaderClass="hide_header" Header=""  DataSource={this.props.getAccordionContent(item)} PopupList={this.props.getPopupContent(item)}/>
                                    }
                                }, this)
                            }
                            </ul>
                        </div>
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
}






// WEBPACK FOOTER.. //
// ./src/components/modules/ModalDialog.js


// WEBPACK FOOTER //
// ./src/components/modules/ModalDialog.js